import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4"
}

import { computed, ComputedRef } from 'vue';
import { UserModel, LevelModel, RoleModel } from '@/types';
import { useAuthStore } from '@/stores';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  setup(__props) {

const authStore = useAuthStore();
const user: ComputedRef<UserModel | undefined> = computed(() => authStore.userModel);

const userLevels = computed(() =>
    authStore.userLevels.map((level: LevelModel) => level.id + ':' + level.name),
);
const userRoles = computed(() =>
    authStore.userRoles.map((role: RoleModel) => role.id + ':' + role.name),
);
const userPermissions = computed(() => authStore.userPermissions);

return (_ctx: any,_cache: any) => {
  return (user.value !== undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", null, "ProfilePage", -1)),
        _createElementVNode("p", null, "id: " + _toDisplayString(user.value.id), 1),
        _createElementVNode("p", null, "name: " + _toDisplayString(user.value.name), 1),
        _createElementVNode("p", null, "email: " + _toDisplayString(user.value.email), 1),
        _createElementVNode("p", null, "levels: " + _toDisplayString(userLevels.value), 1),
        _createElementVNode("p", null, "roles: " + _toDisplayString(userRoles.value), 1),
        _createElementVNode("p", null, "permissions: " + _toDisplayString(userPermissions.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})